import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./hooks/useAuth";
import { FeaturesProvider } from "./context/FeaturesContext";
import { CountryProvider } from "./contexts/CountryContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <AuthProvider>
      <FeaturesProvider>
        <CountryProvider>
          <App />
        </CountryProvider>
      </FeaturesProvider>
    </AuthProvider>
  </React.StrictMode>
);